import React from 'react';
import Block from '../../design-system/chat-blocks/Block';
import Pill from '../../design-system/primitives/Pill';
import Icon from '../../design-system/primitives/Icon';
import { fmtInt, relTime, titleCase } from './format';

const STATUS_TONE = { ok: 'green', error: 'outline', unverified: 'neutral' };
const TYPE_ICON = { snowflake: 'snowflake', bigquery: 'database', databricks: 'layers', redshift: 'server' };
export const PROVIDER_LABEL = { snowflake: 'Snowflake', bigquery: 'BigQuery', databricks: 'Databricks', redshift: 'Redshift' };

// Warehouse connections the entity owns. Metadata only: the backend never
// sends hosts, accounts or credentials.
const ConnectorsBlock = ({ connectors }) => (
  <Block
    icon="database"
    title="Warehouse connectors"
    badge={<Pill tone={connectors.length ? 'accent' : 'neutral'}>{connectors.length}</Pill>}
  >
    {connectors.length === 0 && <p className="qa-muted" style={{ margin: 0 }}>No warehouse connections set up.</p>}
    <div className="qa-conn-list">
      {connectors.map((c) => (
        <div key={c.id} className="qa-conn">
          <span className="qa-conn__icon"><Icon name={TYPE_ICON[c.type] || 'database'} size={15} /></span>
          <span className="qa-conn__body">
            <span className="qa-conn__name">
              {c.name}
              <Pill tone="accent" style={{ padding: '1px 8px', fontSize: 10.5 }}>{PROVIDER_LABEL[c.type] || titleCase(c.type)}</Pill>
              <Pill tone={STATUS_TONE[c.status] || 'neutral'} dot={c.status === 'ok'} style={{ padding: '1px 7px', fontSize: 10.5, ...(c.status === 'error' ? { color: 'var(--danger)', borderColor: 'color-mix(in srgb, var(--danger) 35%, transparent)' } : {}) }}>
                {titleCase(c.status)}
              </Pill>
            </span>
            <span className="qa-conn__meta">
              {c.owner?.username} · created {relTime(c.created_at)}
              {c.last_verified_at && ` · verified ${relTime(c.last_verified_at)}`}
              {c.catalog_cached_at && ` · catalog ${relTime(c.catalog_cached_at)}`}
            </span>
          </span>
          <span className="qa-conn__stats qa-mono">
            {fmtInt(c.datasets_imported)} imports<br />{fmtInt(c.writeback_pipelines)} writebacks
          </span>
        </div>
      ))}
    </div>
  </Block>
);

export default ConnectorsBlock;
